export default {
  'dashboard.router.manager': 'Dashboard',
  'dashboard.summary.organizations': 'Accounts',
  'dashboard.summary.organizations.expired': 'Expired Accounts',
  'dashboard.summary.organizations.due': 'Active Accounts',
  'dashboard.summary.capacityUsed.text': 'In Used Storage',
  'dashboard.summary.capacity.text': 'Total Registered',
  'dashboard.filter.organizations': 'Accounts',
  'dashboard.filter.status': 'Broadcast Status',
  'dashboard.filter.status.active': 'Enabled',
  'dashboard.filter.status.notActive': 'Not Enabled',
  'dashboard.marker.device.name': 'Device Name',
  'dashboard.marker.organizations': 'Account',
  'dashboard.marker.specificAddress': 'Installation Address',
  'dashboard.marker.latitude': 'Latitude',
  'dashboard.marker.longitude': 'Longitude',
  'dashboard.marker.status': 'Broadcast Status',
  'dashboard.marker.device.info': 'Device Information',
  'dashboard.marker.devices.operationStatus.id':
    '{status,select, 1 {Enabled} 2 {Not Enabled} other {Undefined}}',
  'dashboard.summary.facilities': 'Total Locations',
  'dashboard.summary.totalDevice': 'Devices',
  'dashboard.summary.totalNewsletter': 'Total Broadcast',
  'dashboard.summary.capacity': 'Total Capacity',
  'dashboard.summary.totalDevice.label': 'Maximum',
  'dashboard.summary.totalDevice.valueDesc': 'device(s)',
  'dashboard.device.title': 'Device Dashboard',
  'dashboard.device.name': 'Device',
  'dashboard.device.facility.name': 'Location',
  'dashboard.device.deviceGroups': 'Device Group(s)',
  'dashboard.device.connectionStatus': 'Connection Status',
  'dashboard.device.connectionStatus.connecting': 'Connected',
  'dashboard.device.connectionStatus.notConnectedYet': 'Disconnected',
  'dashboard.device.playingStatus': 'Broadcast Status',
  'dashboard.device.playingStatus.playing': 'Broadcasting',
  'dashboard.device.playingStatus.notScheduledYet': 'Not Broadcasting',
  'dashboard.device.playingStatus.undefined': 'Offline Check',
  'dashboard.device.operationStatus': 'Operational Status',
  'dashboard.device.operationStatus.active': 'Enabled',
  'dashboard.device.operationStatus.deactive': 'Not Enabled',
  'dashboard.device.information': 'Information',
  'dashboard.device.filter.connectionStatus': 'Connection Status',
  'dashboard.device.filter.connectionStatus.connecting': 'Connected',
  'dashboard.device.filter.connectionStatus.notConnectedYet': 'Disconnected',
  'dashboard.device.filter.playingStatus': 'Broadcast Status',
  'dashboard.device.filter.playingStatus.playing': 'Broadcasting',
  'dashboard.device.filter.playingStatus.notScheduledYet': 'Not Broadcasting',
  'dashboard.device.filter.playingStatus.undefined': 'Offline Check',
  'dashboard.device.filter.operationStatus': 'Operational Status',
  'dashboard.device.filter.operationStatus.active': 'Enabled',
  'dashboard.device.filter.operationStatus.deactive': 'Not Enabled',
  'dashboard.device.chart.title.connectionStatus': 'Connection Rate',
  'dashboard.device.chart.title.playingStatus': 'Broadcast Status',
  'dashboard.device.chart.title.operationStatus': 'Operation Rate',
  'dashboard.device.chart.title': 'Device List',
  'dashboard.device.export': 'Export excel file',
  'dashboard.marker.device.deviceGroup': 'Device group(s)',
  'dashboard.device.router.nameBreadcrumb': 'Device Dashboard',
  'dashboard.device.connectionStatus.param':
    '{status,select, 1 {Connected} 2 {Disconnected} other {Undefined}}',
  'dashboard.device.playingStatus.param':
    '{status,select, 1 {Broadcasting} 2 {Not Broadcasting} 3 {Offline Check} other {Unknown}}',
  'dashboard.device.operationStatus.param':
    '{status,select, 1 {Enabled} 2 {Not Enabled} other {Undefined}}',
  'dashboard.device.filter.deviceGroup': 'Device Group(s)',
  'dashboard.device.filter.deviceGroup.placeholder': 'Please select device group(s)',
  'dashboard.device.filter.facility': 'Location',
  'dashboard.device.filter.facility.placeholder': 'Please select Location',
  'dashboard.device.chart.head.title': 'Total Devices',
  'dashboard.device.chart.device.unit': 'device(s)',
  'dashboard.device.chart.empty.des': 'No Data Available',
  'dashboard.device.filters.location.label': 'Location',
  'dashboard.device.filters.location.btn.selectAll': 'Select All',
  'dashboard.device.filters.location.btn.deselectAll': 'Deselect All',
  'dashboard.device.filters.location.btn.hideAll': 'Hide All',
  'dashboard.device.filters.location.btn.showAll': 'Show All',
  'dashboard.device.filters.location.search.placeholder': 'Search Location',
  'dashboard.device.filters.location.excludeText': 'Exclude Child Levels',
  'dashboard.device.filters.deviceGr.label': 'Device Group(s)',
  'dashboard.device.filters.deviceGr.search.placeholder': 'Search Device Group(s)',
  'dashboard.device.filters.deviceGr.dropdown.text.choose': 'You are selecting {num} item(s)',
  'dashboard.device.filters.status.label': 'Status',
  'dashboard.device.filters.status.drop.content.all': 'All',
  'dashboard.device.filters.status.drop.content.connect': 'Connection',
  'dashboard.device.filters.status.drop.content.connect.active': 'Connected',
  'dashboard.device.filters.status.drop.content.connect.inactive': 'Disconnected',
  'dashboard.device.filters.status.drop.content.operation': 'Operational',
  'dashboard.device.filters.status.drop.content.operation.active': 'Enabled',
  'dashboard.device.filters.status.drop.content.operation.inactive': 'Not Enabled',
  'dashboard.device.filters.status.drop.content.playing': 'Broadcast',
  'dashboard.device.filters.status.drop.content.playing.play': 'Broadcasting',
  'dashboard.device.filters.status.drop.content.playing.stop': 'Not Broadcasting',
  'dashboard.device.filters.status.drop.content.playing.undefined': 'Offline Check',
  'dashboard.screenshots.device.label.location': 'Location',
  'dashboard.screenshots.device.label.status': 'Status',
  'dashboard.device.screenshots.history.router.nameBreadcrumb': 'Device Screenshot History',
  'dashboard.device.screenshots.history.filters.time': 'Time',
  'dashboard.screenshots.device.label.time': 'Time',
  'dashboard.screenshots.device.no.image': 'No images',
  'dashboard.device.restart.title': 'Device Restart Confirmation',
  'dashboard.device.restart.content': 'The selected device(s) will be restarted',
  'dashboard.device.btn.mode.text.1': 'Grid',
  'dashboard.device.btn.mode.text.2': 'List',
  'dashboard.device.btn.collapsed.1': 'Collapse',
  'dashboard.device.btn.collapsed.2': 'Chart',
  'dashboard.device.version': 'Version',
  'dashboard.device.disconnect.label': 'Days disconnected',
  'dashboard.device.disconnect.second': '{seconds} seconds',
  'dashboard.device.disconnect.minute': '{minutes} minutes',
  'dashboard.device.disconnect.hour': '{hours} hours',
  'dashboard.device.disconnect.day': '{days} days',
  'dashboard.device.disconnect.week': '{weeks} weeks',
  'dashboard.device.disconnect.month': '{months} months',
  'dashboard.device.disconnect.year': '{years} years',

  // 3/4/2026
  'dashboard.filter.status.days': '0 - {days} days',
  'dashboard.filter.status.label.filter': '{min} - {max} days',
  'dashboard.filter.status.label.filter.above': 'Above {day} days',
  'dashboard.filter.status.label.filter.below': 'Below {day} days',
  'dashboard.filter.status.above': 'Above',
  'dashboard.filter.status.bellow': 'Below',
  'dashboard.filter.status.optional': 'Optional',
  'dashboard.filter.status.disconnect.label': 'Disconnection duration (days)',
  'dashboard.filter.status.error.text': 'Start date must be less than or equal to end date',
};
